// extracted by mini-css-extract-plugin
export default {"icon":"OrgsListTableCellSettings_icon__M-J3I","placeHolderShimmer":"OrgsListTableCellSettings_placeHolderShimmer__oZoHu"};